import { render, staticRenderFns } from "./ModalChangeEmail.vue?vue&type=template&id=65237701"
import script from "./ModalChangeEmail.vue?vue&type=script&lang=js"
export * from "./ModalChangeEmail.vue?vue&type=script&lang=js"
import style0 from "./ModalChangeEmail.vue?vue&type=style&index=0&id=65237701&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports